/** 本机发货易小助手。响应为 `{ code, successful, message, data }`。 */
import axios from "axios";

const HELPER_ORIGIN = "http://127.0.0.1:18188";
const REQUEST_TIMEOUT_MS = 3000;

const helperAxios = axios.create({
    baseURL: HELPER_ORIGIN,
    timeout: REQUEST_TIMEOUT_MS,
    validateStatus: () => true,
});

export enum ShipEasyRecordMode {
    Idle = "idle",
    Preview = "preview",
    Recording = "recording",
}

export interface ShipEasyApiResponse<T> {
    code: number;
    successful: boolean;
    message: string;
    data: T;
}

export interface ShipEasyRecordStatusData {
    mode: ShipEasyRecordMode;
    waybill: string;
}

export function getShipEasyRecordStatus(): Promise<ShipEasyApiResponse<ShipEasyRecordStatusData>> {
    return helperAxios.get("/api/record/status").then((response) => response.data);
}

export function stopShipEasyRecording(): Promise<ShipEasyApiResponse<null>> {
    return helperAxios.post("/api/record/stop").then((response) => response.data);
}

export function startShipEasyRecording(waybill: string): Promise<ShipEasyApiResponse<null>> {
    return helperAxios.post("/api/record", { waybill }).then((response) => response.data);
}
